export function calculateDv(ruc: string | number){
    let basemax = 11;
    let sum = 0;
    let factor = 2;
    let rev_num = (ruc+"").split("").reverse();

    rev_num.forEach(char => {
        factor = factor > basemax ? 2 : factor;
        sum += factor * parseInt(char);
        factor += 1;
    });

    let rest = sum % 11;
    return rest > 1 ? 11 - rest : 0;
}

export function numberWithCommas(x: number | string): string {
  if (typeof x === "string") {
    x = parseInt(x.replace(/\./g, "").replace(/,/g, "."));
  }
  return (x as number).toLocaleString("es-py", { maximumFractionDigits: 4 });
}